import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Select, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from '../components/FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'

@inject('jobManagementStore', 'mappingManagementStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
    importModalVisible: false,
  }
  formRef = React.createRef()

  componentDidMount() {
    const {jobManagementStore, mappingManagementStore} = this.props
    jobManagementStore.onSearchJobAction({page: 1, size: PAGE_SIZE_DEFAULT})
    jobManagementStore.onOptionsAction()
    mappingManagementStore.onGetinboundCustomerAction()
    mappingManagementStore.onGetoutboundCustomerAction()
  }

  handleSearch = () => {
    const {jobManagementStore} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'jobName': fieldsValue.jobName,
        'jobType': fieldsValue.jobType,
        'jobStatus': fieldsValue.jobStatus,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      jobManagementStore.onSearchJobAction(params)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {jobManagementStore, location, t} = this.props
    const {jobType, jobStatus} = jobManagementStore
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={4}>
              <Form.Item name="jobType" label={t(`job.jobType`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  {jobType?.map(item => (<Select.Option key={item.code} value={item.code}>{item.label}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="jobName" label={t(`job.jobName`)}
                         rules={[{
                           message: `${t(`general.pleaseEnter`)} ${t(`job.jobName`)} ${t(`general.withoutSpecialChats`)}`,
                           pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                         }]}>
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="jobStatus" label={t(`job.status`)}>
                <Select placeholder={t(`general.pleaseSelect`)} allowClear>
                  {jobStatus?.map(item => (<Select.Option key={item.code} value={item.code}>{item.label}</Select.Option>))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8} offset={4} style={{textAlign: 'right', marginTop: 30}}>
              <Button onClick={this.handleSearch} type='danger'>{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)
